import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';
import { Announcement } from '../features/common/announcements/type/Announcement';

export const useGetAnnouncements = (archive: boolean, userName: string) => {
    const { data, isLoading } = useQuery({
        queryKey: ['announcements', archive, userName],
        queryFn: async () => await apiClient.get('announcement/list', {
            params: {
                archive
            }
        }) as Announcement[]
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};

export const useGetUnreadAnnouncementCount = (userName: string) => {
    const { data, isLoading } = useQuery({
        queryKey: ['unread-announcement-count', userName],
        queryFn: async () => await apiClient.get('announcement/unread-count') as number
    });

    return {
        data,
        isLoading
    };
};